import React from 'react';
import NavBar from '../../components/Navbar/NavBar';
import FooterOne from '../../components/Footer/Footer';
import { Container, Grid, Typography, Link, Box, useTheme, useMediaQuery } from '@mui/material';
import Partners from '../../components/Partners';

function FriendsOfBeads() {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('md'));

    return (
        <Box>
            <NavBar />
            <Container sx={{ my: 12, mx: 'auto' }}>
                <Typography variant="h3" gutterBottom align="center" sx={{ my: 3 }}>
                    Friends of Beads
                </Typography>

                <Grid container spacing={isMobile ? 2 : 4}>
                    <Grid item xs={12} md={6}>
                        <Box sx={{ mb: 5 }}>
                            <Typography variant="h5" gutterBottom>
                                <Link href="https://www.aidforafrica.org/" target="_blank" rel="noopener noreferrer"
                                    sx={{ textDecoration: 'none' }}>Aid for Africa
                                </Link>
                            </Typography>

                            <Typography paragraph>
                                Aid For Africa, a coalition of over 100 US-registered nonprofits, worked to support various initiatives in Sub-Saharan Africa, raising funds, amplifying successes, and establishing an endowment for food and sustainable agriculture research before ceasing operations in 2020.
                            </Typography>
                        </Box>

                        <Box sx={{ mb: 5 }}>

                            <Typography variant="h6" gutterBottom>
                                <Link href="https://deeperafrica.com/" target="_blank" rel="noopener noreferrer"
                                    sx={{ textDecoration: 'none' }}>Deeper Africa
                                </Link>
                            </Typography>

                            <Typography paragraph>
                                Deeper Africa specializes in personalized adventures across East, Central, and Southern Africa, offering access to hidden gems and wildlife encounters facilitated by experts deeply connected to the land, ensuring an enriching experience that celebrates Africa's treasures and fosters a commitment to its future.
                            </Typography>
                        </Box>

                        <Box sx={{ mb: 5 }}>

                            <Typography variant="h6">
                                <Link href="https://donhebert.com/" target="_blank" rel="noopener noreferrer"
                                    sx={{ textDecoration: 'none' }}>Don Hebert Photography
                                </Link>
                            </Typography>

                            <Typography paragraph>
                                <strong>MANY OF THE BEAUTIFUL PHOTOS ON THIS SITE PROVIDED BY;</strong> Don Hebert Photography, offering over 30 years of expertise in capturing stunning architectural imagery in island settings, utilizing advanced techniques to showcase properties in their natural light and breathtaking surroundings.
                            </Typography>
                        </Box>

                        <Box sx={{ mb: 5 }}>
                            <Typography gutterBottom>TO LEARN MORE ABOUT THE KENYAN POPULATION AND ENVIRONMENT, VISIT SOME OF THE LINKS LISTED BELOW :</Typography>
                            <Box>
                                {["https://www.nwf.org/", "http://gardenofeve.org/", "http://conservation.wdwpublicaffairs.com/", "https://www.africaguide.com/", "https://www.africa.com/"].map((link, index) => (
                                    <Typography key={index} variant="h6" gutterBottom>
                                        <Link href={link} target="_blank" rel="noopener noreferrer" sx={{ textDecoration: 'none' }}>{link}</Link>
                                    </Typography>
                                ))}
                            </Box>
                        </Box>
                    </Grid>

                    <Grid item xs={12} md={6}>
                        <img src="assets/img/friends/elephant.jpg" alt="Friends of Beads" style={{ width: '100%', height: 'auto' }} />
                    </Grid>
                </Grid>
            </Container>

            <Box sx={{ mb: 5 }}>
                <Partners
                    title="Our Sponsors"
                    subtitle="WE ARE VERY GRATEFUL FOR THE SUPPORT OF OUR LONG-TIME CORPORATE SPONSORS :"
                />
            </Box>

            <FooterOne />
        </Box>
    );
}

export default FriendsOfBeads;
